/* External */
import React from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Icon from '@dtvgo/icon';

/* Components */
// import { useIntl } from 'react-intl';
import MenuButton from '../MenuButton/MenuButton';

/* Styles */
import './GuideButton.scss';

function GuideButton({ goToGuideHandler }) {
  // const { formatMessage } = useIntl();
  return (
    <MenuButton
      handleClick={goToGuideHandler}
      onClick={goToGuideHandler}
      showOnClick={false}
      buttonContent={(
        <div className="dtv-guide-content-button">
          <Icon name="list-bullet" />
          {/* <div className="dtv-guide-tooltip">
            {formatMessage({ id: 'player.guide' })}
          </div> */}
        </div>
        )}
      className="dtv-common-c-guide-button"
      id="btn-more-channels"
    />
  );
}

GuideButton.propTypes = {
  goToGuideHandler: PropTypes.func,
};

GuideButton.defaultProps = {
  goToGuideHandler: () => {},
};

export default GuideButton;
